import { Button, FormFileInput, LoadingIndicator, useModal } from '../../../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { pagarNota } from '../../core/_requests'
import { useFormik } from 'formik'
import { pagarNotaSchema } from './validation/pagarNotaSchema'

type IProps = {
  idNota: number
}

export const PagarNotaModal = ({ idNota }: IProps) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      pdf: undefined as File | undefined,
    },
    validationSchema: pagarNotaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        await pagarNota(idNota, values.pdf as File)
        showAlert({ title: 'Sucesso', text: 'Nota marcada como paga!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormFileInput
        formik={formik}
        name='pdf'
        accept='application/pdf'
        label='Comprovante'
        isDisabled={formik.isSubmitting}
      />

      <div className='d-flex justify-content-center mt-5'>
        <Button className='btn-secondary me-2' onClick={closeModal}>
          Cancelar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Enviar'}
        </Button>
      </div>
    </form>
  )
}
